import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";

const OUTCOME_LABELS = {
  highly_interested: "Highly interested", requested_proposal: "Requested proposal", needs_followup: "Needs follow-up",
  needs_info: "Needs more info", not_a_fit: "Not a fit", no_show: "No-show",
};
const pretty = (k) => OUTCOME_LABELS[k] || String(k).replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

function Stat({ label, value, color, testid }) {
  return (
    <div data-testid={testid} style={{ flex: 1, minWidth: 110, padding: "10px 12px", border: "0.5px solid #eee", borderRadius: 10 }}>
      <div style={{ fontSize: 10, color: "#888", textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</div>
      <div style={{ fontSize: 20, fontWeight: 700, color, marginTop: 2, fontVariantNumeric: "tabular-nums" }}>{value}</div>
    </div>
  );
}

/** Reports → Client Demo Activity (EHI client demos only) for the selected range. */
export default function ClientDemoActivity({ from, to, Card }) {
  const { token } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    const params = {};
    if (from) params.date_from = from;
    if (to) params.date_to = to;
    axios.get(`${API}/demo-bookings/client-activity`, { params, headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setD(r.data)).catch(() => setD({}));
  }, [token, from, to]);
  const outcomes = Object.entries(d?.outcomes || {}).sort((a, b) => b[1] - a[1]);
  const maxO = Math.max(1, ...outcomes.map(([, v]) => v));
  return (
    <Card title="Client Demo Activity" sub="Demos with existing EHI clients only, by demo date in the selected range">
      <div data-testid="client-demo-activity" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <Stat testid="client-demo-total" label="Client demos" value={d?.total ?? "—"} color="#111" />
          <Stat testid="client-demo-completion-rate" label="Completion rate" value={d ? `${d.completion_rate ?? 0}%` : "—"} color="#15803d" />
          <Stat testid="client-demo-no-show-rate" label="No-show rate" value={d ? `${d.no_show_rate ?? 0}%` : "—"} color="#b91c1c" />
          <Stat testid="client-demo-cancelled" label="Cancelled" value={d?.cancelled ?? "—"} color="#64748b" />
        </div>
        <div style={{ fontSize: 10.5, color: "#94a3b8" }}>
          Completed {d?.completed ?? 0} · No show {d?.no_show ?? 0} · Scheduled {d?.scheduled ?? 0} · Rescheduled {d?.rescheduled ?? 0}. Rates are out of demos that were held or missed.
        </div>
        <div data-testid="client-demo-outcomes">
          <div style={{ fontSize: 11, fontWeight: 600, marginBottom: 6 }}>Outcome breakdown</div>
          {outcomes.length === 0 ? (
            <div style={{ fontSize: 11, color: "#94a3b8" }}>No client demo outcomes logged in this range.</div>
          ) : outcomes.map(([k, v]) => (
            <div key={k} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 5 }}>
              <div style={{ width: 150, fontSize: 11, color: "#444" }}>{pretty(k)}</div>
              <div style={{ flex: 1, height: 8, background: "#f1f5f9", borderRadius: 4 }}>
                <div style={{ width: `${(v / maxO) * 100}%`, height: "100%", background: "#2563eb", borderRadius: 4 }} />
              </div>
              <div style={{ width: 28, textAlign: "right", fontSize: 11, fontVariantNumeric: "tabular-nums" }}>{v}</div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
